// import type { ApiLogDetail } from '@/dto/ApiLog'
import type { ApiLogDetail } from '../../dtos/Api/ApiLog'
import { LabelValueGrid } from './LogDetail'

export const ApiLogHeaders = ({ apiLogDetail }: { apiLogDetail: ApiLogDetail }) => {
    const headers = parseHeadersToRows(apiLogDetail?.headers || '')

    return (
        <LabelValueGrid rows={headers} />
    )
}

export function parseHeadersToRows(headerText: string): [string, React.ReactNode][] {
    return headerText
        .split('\r\n')
        .filter(line => line.trim() !== '')
        .map(line => {
            const [key, ...rest] = line.split(':')
            const value = rest.join(':').trim()
            return [key.trim(), value]
        })
}